
// `x-charts-vendor/d3-path` (CommonJS)
// See upstream license: https://github.com/d3/d3-path/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-path`
module.exports = require("../lib-vendor/d3-path/src/index.js");
